// @ts-nocheck
import { Clipboard } from 'react-native-web';

export default Clipboard;